@if ((isNavBarEnabled$ | async) && (isTemplate$ | async) === false) {
  <app-atlas-nav></app-atlas-nav>
}

<glxy-nav
  #nav
  [fixedTopGap]="(isNavBarEnabled$ | async) && (isTemplate$ | async) === false ? 40 : 0"
  appName="website"
  [navAutoSize]="true"
  class="glxy-nav--light-theme"
  >
  <glxy-nav-panel>
    <glxy-nav-header>
      <div class="glxy-product-nav-header">
        @if (logoUrl$ | async) {
          <img src="{{ logoUrl$ | async }}" alt="logo" class="app-logo" />
        }
        <span class="app-name">
          {{ productNameWithCurrentEdition$ | async }}
        </span>
      </div>
    </glxy-nav-header>

    @if (isExpress$ | async) {
      <div class="glxy-upgrade-section">
        <div class="upgrade-info">{{ upgradedText$ | async }}</div>
        <div class="upgrade-action-button" (click)="upgradeClicked()">
          <div class="upgrade-action-button-text">
            {{ 'UPGRADE_CTA.GET_PRO' | translate }}
          </div>
        </div>
      </div>
    }

    <div class="glxy-nav-items">
      @if (sidebarPrimaryActionButton$ | async) {
        <div class="glxy-product-primary-action-button">
          <span class="primary-action-button-icon">
            <img src="https://vstatic-prod.apigateway.co/wsp-portal-client.9223372035070662493.demo/assets/wordpress-logo.svg" alt="logo" />
          </span>
          <span
            data-action="wordpress-open-dashboard"
            data-action-group="open-wordpress"
            class="primary-action-button-text"
            (click)="wordPressDashboardClicked()"
            >
            {{ 'PAGES.OVERVIEW.MANAGE_SITE_MODAL.WORDPRESS_DASHBOARD' | translate }}
          </span>
        </div>
        @if (isPartner$ | async) {
          <div>
            <div class="glxy-product-admin-action-button">
              <button
                mat-flat-button
                color="primary"
                (click)="adminDashboardClicked()"
                class="glxy-product-admin-action-button"
                >
                <mat-icon>dashboard</mat-icon>
                {{ 'PAGES.OVERVIEW.MANAGE_SITE_MODAL.ADMIN_DASHOBOARD' | translate }}
              </button>
            </div>
          </div>
        }
      }
      @if (navItems$ | async; as navItems) {
        @for (navItem of navItems; track navItem) {
          <glxy-nav-item [route]="navItem.url" [icon]="navItem.icon">
            {{ navItem.label | translate }}
            @if (navItem.showUpgradeChip) {
              <glxy-badge color="blue">
                {{ 'UPGRADE_CTA.PRO_CHIP' | translate }}
              </glxy-badge>
            }
          </glxy-nav-item>
        }
      }
    </div>

    <glxy-nav-footer>
      @if (partnerConfig$ | async; as config) {
        <div class="glxy-product-powered-by">
          @if (config.logo) {
            <img class="powered-by-logo" [src]="config.logo" alt="logo" />
          }
          @if (config.name) {
            <div class="powered-by-text">
              {{ 'NAVIGATION.FOOTER.POWERED_BY' | translate }}
              <b>{{ config.name }}</b>
            </div>
          }
        </div>
      }
    </glxy-nav-footer>
  </glxy-nav-panel>

  <!-- Page Content -->
  <router-outlet></router-outlet>
</glxy-nav>

<div aria-live="polite" class="webchat-fallback-live-region">
  @if ((webchatFailed$ | async) && (shouldShowWidget$ | async)) {
    <a
      mat-fab
      extended
      color="primary"
      id="webchat-fallback"
      class="webchat-fallback"
      href="mailto:support@vendasta.com"
      aria-label="Contact support by email"
    >
      <mat-icon>mail</mat-icon>
      Chat unavailable &mdash; email support
    </a>
  }
</div>
